import { render, staticRenderFns } from "./DemoModal.vue?vue&type=template&id=ac8ceb5e&scoped=true"
import script from "./DemoModal.vue?vue&type=script&lang=js"
export * from "./DemoModal.vue?vue&type=script&lang=js"
import style0 from "./DemoModal.vue?vue&type=style&index=0&id=ac8ceb5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac8ceb5e",
  null
  
)

export default component.exports